'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  SOUND: 'notificationSoundEnabled',
  PUSH: 'browserNotificationEnabled',
  TAB: 'tabFlashNotificationEnabled',
  EMAIL: 'initialEmailNotificationEnabled'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/constants/NotificationTypes.js
// module id = 430
// module chunks = 0